import { canUseDOM } from 'exenv';
import { useEffect, useState } from 'react';

type TBrowserPlatform = 'win' | 'mac' | 'linux';

export const useBrowserPlatform = (): TBrowserPlatform => {
  const [platform, setPlatform] = useState<TBrowserPlatform>('win');

  useEffect(() => {
    if (canUseDOM && navigator) {
      const ua = navigator.userAgent || '';
      if (ua.indexOf('Mac') !== -1 || ua.indexOf('Darwin') !== -1) {
        setPlatform('mac');
      } else if (ua.indexOf('Linux') !== -1 || ua.indexOf('linux') !== -1 || ua.indexOf('Ubuntu') !== -1) {
        setPlatform('linux');
      }
    }
  }, []);

  return platform;
};
